import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-polyglot'
import ConditionDetailsFleetModal from '../../../../components/management/fleets/conditions/ConditionDetailsFleetModal'
import { closeConditionDetailsFleetModal, fetchConditionDetailsFleetSuccess, fetchConditionDetailsFleet } from '../../../../actions/management/auxModals/auxModals'
import TrackingContainer from '../../../tracking/trackingContainer'

export function mapStateToProps (state) {
  return {
    ...state.managementAuxModals.conditionDetailsFleetModal
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      closeConditionDetailsFleetModal,
      fetchConditionDetailsFleetSuccess,
      fetchConditionDetailsFleet
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(TrackingContainer(ConditionDetailsFleetModal, true)))
